export default __webpack_public_path__ + "static/media/190629_190332_IMG_6001.e9eb5267.jpg";